import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagLoteProductosFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagLoteProductos'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagLoteProductos' label='Uso de lotes en productos' />
      )}
    </Field>
  )
}

export default React.memo(FlagLoteProductosFormGroup)
